module.exports = __webpack_public_path__ + "img/nex.3457f76b.jpeg";